import React from 'react'
import { Link } from 'react-router-dom'

export default class ListLogRowComponent extends React.Component {
	render() {
		return (
			<tr>
				<td>{ this.props.log.text_created_at }</td>
				<td><Link to={'/admin/khach-hang/chi-tiet-khach-hang/' + this.props.log.user_id }>{ this.props.log.text_user }</Link></td>
				<td>
                    <div dangerouslySetInnerHTML={{ __html: this.props.log.admin }} />
                    {
                        this.props.log.ip.length ? (
                            <> từ IP {this.props.log.ip}</>
                        ) : (
                            <></>
                        )
                    }
                </td>
				<td>{ this.props.log.service }</td>
			</tr>
		)
	}
}